






import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import {
  AccountsSummary,
  Home,
  HsabAccountSelection,
  HsabNotionalDashboard,
  SamlError
} from "@/employee/route-names";
import { TokenResponse } from "@okta/okta-auth-js";
import { oktaAuthApi } from "@/shared/api/oktaAuthApi";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as datadog from "@/shared/datadog";
import {
  AuthType,
  LoginMethod,
} from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useUserStore } from "@/shared/store/user";
import { useRootStore } from "@/shared/store/root";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class OktaSso extends Vue {
  hsabAccountStore = useHsabAccountsStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  rootStore = useRootStore();

  created () {
    if (this.userStore.loggedIn) {
      this.rootStore.resetState();
    }
  }

  mounted () {
    oktaAuthApi.token.getWithoutPrompt()
        .then(response => {
          this.handleLogin(response);
        })
        .catch(error => {
          this.handleError(error);
        });
  }

  handleLogin (response: TokenResponse) {
    oktaAuthApi.tokenManager.setTokens(response.tokens);
    this.userStore.setAuthType(AuthType.Okta);
    this.userStore.setLoginMethod(LoginMethod.Sso);
    this.userStore.login({ username: "" });
  }

  handleError (error: any) {
    const message = error.errorSummary
        ? `Error in Okta SSO: ${error.errorSummary}`
        : "Error in Okta SSO";
    datadog.log(message, { ...error, fullPath: this.$route.fullPath }, "error");
    this.$router.push({ name: SamlError });
  }

}
